import { AxiosError } from "axios";

export function errorHandler({ error, message }: { error: unknown; message?: string }) {
  if (error instanceof AxiosError) {
    throw new Error(error?.response?.data || message);
  }

  if (error instanceof Error) {
    throw new Error(error?.message || message);
  }

  throw new Error("An unknown error occurred...");
}
